<template>
  <div class="card border-0 shadow-sm"> <!-- Apply card styling here -->
    <div class="card-body">
      <div class="row text-center mb-3">
        <div class="col-6">
          <h2 class="text-danger">{{ outOfStockProductsCount }}</h2>
          <p class="text-muted">{{ $t('competitorInventoryStatus.outOfStockProducts') }}</p>
        </div>
        <div class="col-6">
          <h2 class="text-info">{{ totalMonitoredProductsCount }}</h2>
          <p class="text-muted">{{ $t('competitorInventoryStatus.totalMonitored') }}</p>
        </div>
      </div>
      <div class="mb-3">
        <p class="mb-1">{{ $t('competitorInventoryStatus.outOfStockRate') }}</p>
        <div class="progress" style="height: 10px;">
          <div class="progress-bar" :class="progressBarClass" role="progressbar" :style="{ width: outOfStockRate + '%' }" :aria-valuenow="outOfStockRate" aria-valuemin="0" aria-valuemax="100"></div>
        </div>
        <p class="text-end mt-1" :class="rateTextColor">{{ outOfStockRate.toFixed(1) }}%</p>
      </div>
      <div class="text-center">
        <p class="mb-0" :class="messageTextColor">
          <i class="fas fa-info-circle me-1"></i>
          {{ statusMessage }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import apiClient from '../api';

export default {
  name: 'CompetitorInventoryStatus',
  data() {
    return {
      outOfStockProductsCount: 0,
      totalMonitoredProductsCount: 0,
      outOfStockRate: 0.0,
      statusMessage: '',
    };
  },
  computed: {
    progressBarClass() {
      if (this.outOfStockRate > 30) return 'bg-danger';
      if (this.outOfStockRate > 10) return 'bg-warning';
      return 'bg-success';
    },
    rateTextColor() {
      if (this.outOfStockRate > 30) return 'text-danger';
      if (this.outOfStockRate > 10) return 'text-warning';
      return 'text-success';
    },
    messageTextColor() {
      if (this.outOfStockRate > 30) return 'text-danger';
      if (this.outOfStockRate > 10) return 'text-warning';
      return 'text-success';
    }
  },
  async created() {
    await this.fetchCompetitorInventoryStatus();
  },
  methods: {
    async fetchCompetitorInventoryStatus() {
      try {
                const response = await apiClient.get('/ci/competitor_inventory_status');
        const data = response.data;
        this.outOfStockProductsCount = data.out_of_stock_products_count;
        this.totalMonitoredProductsCount = data.total_monitored_products_count;
        this.outOfStockRate = data.out_of_stock_rate;
        this.statusMessage = data.status_message;
      } catch (error) {
        console.error('Error fetching competitor inventory status:', error);
        this.statusMessage = this.$t('competitorInventoryStatus.errorFetching');
      }
    },
  },
};
</script>

<style scoped>
.card-body {
  padding: 1.5rem;
}
.progress {
  background-color: #e9ecef;
}
</style>